export default "__VITE_ASSET__1e4618d9__"